import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 원더플 피플! ")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 참여 중인 챌린지 유형을 ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("선택해주세요. ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 도전하고 싶은 챌린지 유형을 ")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("선택해주세요. ")
const _hoisted_10 = { class: "dialog-content" }
const _hoisted_11 = {
  key: 0,
  class: "desc"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("제로 웨이스트 박스 1개의 크기는 과거 가장 큰 사이즈였던 "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("종량제 쓰레기 봉투 100리터 기준 3/4 정도입니다. (73.5리터)")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("챌린지 유형은 신청 후 변경이 불가합니다. "),
  /*#__PURE__*/_createElementVNode("br", { class: "d-block d-md-none" }),
  /*#__PURE__*/_createTextVNode("신중하게 선택해주세요.")
], -1)
const _hoisted_15 = [
  _hoisted_12,
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "box-img" }
const _hoisted_18 = { class: "text" }

import { ColorVariants } from '@/constants';
import ResponsiveImage from '../responsive-image.vue';

interface Props {
  visible: boolean;
  modelValue: number;
  buttonDisabled?: boolean;
  isCollection?: boolean;
}
interface Emits {
  (event: 'update:visible', value: boolean): void;
  (event: 'update:model-value', value: typeof challengeTypes[number]['value']): void;
  (event: 'button-click') :void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    visible: { type: Boolean },
    modelValue: null,
    buttonDisabled: { type: Boolean },
    isCollection: { type: Boolean }
  },
  emits: ["update:visible", "update:model-value", "button-click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'update:visible', value: boolean): void;
  (event: 'update:model-value', value: typeof challengeTypes[number]['value']): void;
  (event: 'button-click') :void;
}), expose: any, slots: any, attrs: any }) {




const challengeTypes = [
  {
    img: require('./2.png'),
    imgWebp: require('./2.webp'),
    value: 2,
    text: '2박스 챌린지'
  },
  {
    img: require('./4.png'),
    imgWebP: require('./4.webp'),
    value: 4,
    text: '4박스 챌린지'
  }
];

return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_component_AppDialog, {
    visible: __props.visible,
    class: "dialog-campaign-participate-step-1",
    btns: [
      { text: '다음', style: _unref(ColorVariants).danger, click: () => emits('button-click'), disabled: __props.buttonDisabled }
    ],
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => (emits('update:visible', $event)))
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        (__props.isCollection)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_4,
              _hoisted_5,
              _hoisted_6
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_7,
              _hoisted_8,
              _hoisted_9
            ], 64))
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_10, [
        (!__props.isCollection)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_15))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["choose-type", { 'has-desc': !__props.isCollection }])
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(challengeTypes, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: _normalizeClass(["item", { active: __props.modelValue === item.value }]),
              onClick: ($event: any) => (emits('update:model-value', item.value))
            }, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(item.text), 1),
                _createVNode(ResponsiveImage, {
                  class: "d-none d-md-block",
                  image: item.img,
                  "image-webp": item.imgWebP
                }, null, 8, ["image", "image-webp"])
              ])
            ], 10, _hoisted_16)
          }), 64))
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["visible", "btns"]))
}
}

})